export { default as tooltipTemplate } from './tooltip.dot';
export { default as tooltipContainerTemplate } from './tooltipContainer.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/core/tooltip/templates/index.ts